export enum RecurringPaymentStatus {
  ACTIVE = 0,
  CANCELLED = 1,
}
